import { render } from "./CharlaLangPopup.vue?vue&type=template&id=7ce77152&scoped=true"
import script from "./CharlaLangPopup.vue?vue&type=script&lang=js"
export * from "./CharlaLangPopup.vue?vue&type=script&lang=js"

import "./CharlaLangPopup.vue?vue&type=style&index=0&id=7ce77152&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce77152"]])

export default __exports__